import { ActiveFilters, SEARCH_DEFAULT_SORT_BY } from 'store/search/types';

const getParam = (query: URLSearchParams | any, paramName: string) => {
  const paramValue = query instanceof URLSearchParams ? query.get(paramName) : query[paramName];
  return decodeURIComponent(paramValue || '');
};

const parseFilters = (s: string) => {
  if (!s) {
    return {};
  }
  try {
    return JSON.parse(decodeURIComponent(s));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error parsing filter string', e);
  }
  return {};
};

const parseSearchPageParams = (query: URLSearchParams | any) => ({
  filters: parseFilters(getParam(query, 'filters')) as ActiveFilters,
  pageNr: Number(getParam(query, 'pageNr')) || 1,
  sortBy: getParam(query, 'sortBy') || SEARCH_DEFAULT_SORT_BY,
  query: getParam(query, 'query'),
});

export default parseSearchPageParams;
